var map = {
	"./Accordion.svg": 532,
	"./Breadcrumb.svg": 533,
	"./Button.svg": 534,
	"./Checkbox.svg": 535,
	"./Code snippet.svg": 536,
	"./Content switcher.svg": 537,
	"./Data table.svg": 538,
	"./Date picker.svg": 539,
	"./Dropdown.svg": 540,
	"./File uploader.svg": 541,
	"./Form.svg": 542,
	"./Inline loading.svg": 543,
	"./Link.svg": 544,
	"./List.svg": 545,
	"./Loading.svg": 546,
	"./Modal.svg": 547,
	"./Multiselect.svg": 548,
	"./NoImage.svg": 319,
	"./Notification.svg": 549,
	"./Number input.svg": 550,
	"./Overflow menu.svg": 551,
	"./Pagination.svg": 552,
	"./Progress indicator.svg": 553,
	"./Radio button.svg": 554,
	"./Search.svg": 555,
	"./Select.svg": 556,
	"./Slider.svg": 557,
	"./Structured list.svg": 558,
	"./Tabs.svg": 559,
	"./Tag.svg": 560,
	"./Text input.svg": 561,
	"./Tile.svg": 562,
	"./Toggle.svg": 563,
	"./Tooltip.svg": 564,
	"./UI shell.svg": 565
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;